import firebase from 'firebase/app';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebaseui from 'firebaseui';

// ---------- In project imports ----------

import { auth } from './initFirebase';

import { Modal } from './UI';

const uiConfig: firebaseui.auth.Config = {
	signInFlow: 'popup',
	signInOptions: [
		firebase.auth.GoogleAuthProvider.PROVIDER_ID,
	],
	callbacks: {
		signInSuccessWithAuthResult: res => (console.log('sign in success', res), false)
	},
};

function WelcomeScreen(
	{ authState } :
	{ authState: [firebase.User | null | undefined, boolean, firebase.auth.Error | undefined] }
) {
	const [user, userLoading, userError] = authState;

	return <Modal>{
		userLoading ? 'Loading' :
		userError ? 'Error: ' + JSON.stringify(userError) :
		<div>
			<h1>Welcome to Tank Tactics</h1>
			<h2>It was banned, but I remade it for you</h2>
			<p>
				Tank Tactics is a simple looking <b>online multiplayer</b> game about cooperation and trust. But don't let the appearance fool you. The game was so engaging that it had to be banned from the studio where it was born - Halfbricks (creator of "Fruit Ninja", "Jetpack Joyride" and others). You can watch the video about the game and why it was banned here:
			</p>
			<p style={{ textAlign: 'center' }}>
				<iframe width="560" height="315" src="https://www.youtube.com/embed/aOYbR-Q_4Hs" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
			</p>
			<p>
				Read <b>rules</b> on game's itch.io page: <a href="https://nns2009.itch.io/tank-tactics" target="_blank">nns2009.itch.io/tank-tactics</a>
			</p>
			<p>
				The game is going to take a couple of weeks to complete, probably, but it shouldn't require more than a few minutes of your time each day ... At least that's what the original game creator Luka Muscat thought before they had started playing.
			</p>
			<p>
				Start playing with your friends - end playing with your ex-friends! <br />
				You can create private rooms accessible only by invite code.
			</p>
			<p>
				Or join a group of strangers - your choice!
			</p>
			<p>
				I didn't have time to work on styles so the game looks like garbage, sorry. Also, <u>it poorly works in Firefox</u>. Use Chromium-based browser, such as <b>Chrome, Edge, Opera, Yandex</b>.
			</p>
			<p>
				Did I mention this game has been banned? Ok, you've been warned.
			</p>
			<StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
		</div>
	}</Modal>
}

export default WelcomeScreen;
